module.exports = __webpack_public_path__ + "img/icon-link-green.c3dda607.svg";